import {relations as api} from '@app/api'
import string from '@lib/string'
/**
 * 
 *   Usage: See clsList for examples, API and implementation notes. 
 *   In addition to the default functionallity, this list is capable refreshing a relation so that the 
 *   addresses and contacts are available. 
 * 
 *   Note, as the relations list is typically a large list, refreshing data is done on a per-relation basis.
 *   This means that when a relation is saved, either a new relation is appended to the list, or the properties of
 *   the existing relation are updated.
 *   
 *   This does not work as e.g. a list of disputes, which is refreshed entirely after a save. 
 * 
 *   The caveyat of this is that when changing a property of an item in a complex list, reactivity is not 
 *   triggered. That means that when e.g. the nae of a relation is updated, it is not immediately reflected 
 *   in a combobox (even though the list itself is udpated). Therefore, after an update, the list is refreshed 
 *   by a trick: list = list.slice(). This creates a new array, which does trigger reactivity. 
 * 
 *   Note also, that this is only applicable for relations and therefore is implemented only here.
 */
import clsList from '@cls/clsList'

 
class clsRelation extends clsList {
 
    // Relace the list by a new array to trigger reactivity.
    invalidateList() {
        this.list = this.list.slice();
    }
    // In addition to the base functionallity, invalidate the list. 
    updateRow(data) {
        super.updateRow(data);
        this.invalidateList();
    }

    /**
     * List relations which can be used in sales related functionallity
     * @param {} id 
     * @returns 
     */
    listSales(id) {
        let items = this.listActual(id);
        items = (items||[]).filter ((v) => !!v.use_in_sales || v.id == id); 
        return items;
    }
    /**
     * List relations which can be used in purchase related functionallity
     * @param {} id 
     * @returns 
     */
    listPurchase(id) {
        let items = this.listActual(id);
        items = (items||[]).filter ((v) => !!v.use_in_purchase || v.id == id); 
        return items;
    }

    /**
     * We have custom functionallity for updating after a save event.
     * Instead of refreshin gthe list, we refresh the affected relation only.
     * 
     * @param {*} entityName 
     * @param {*} data 
     */
    onModelSavedEvent(entityName, data) {
        // When a relation is saved, the refreshed item is sent along with the event.
        if (entityName == this.modelName) {
            if (data && data.rel_name) { // The data was sent along                
                this.updateRow(data);
            } else {
                this.refresh(data.id || data.id_relation, true)
            }            
        // Otherwise when an address, contact or bank account is saved, refresh the relation. 
        } else if (string.isInRange(entityName, "relation_contact", "relation_address", "relation_bankaccount")  && data.id_relation) {
            this.refresh(data.id_relation, true)
        }
        // else, the event is not for us.
    };
    contactFor(id_relation, id_contact) {
        var relation = this.one(id_relation);
        if (!relation || !relation.contactpersons) {
            return null;
        }
        return (relation.contactpersons||[]).find( (c) => c.id == id_contact);
    }
    /**
     * Refresh the relation from the server.
     */
    async refresh(id) {
        var obj = await api.load(id)
        if (obj && obj.data) {
            obj = obj.data;
        }
    
        // This does not work. as it overwrites the array index.
        //   this.updateRow(obj);

        var row = this.list.find( (x) => x.id == id);
        if (!row) {
            console.error("updateRow - updatable row not found.");
            return;    
        }
        // Overwrite all object properties, including the bank accountants, addresses, et all.
        for (var key in obj) {
            row[key] = obj[key];
        }
        // row.bankaccounts = obj.bankaccounts;
//        this.updateRow(obj);

        // Invalidate the list to trigger reactivity.
        this.invalidateList();
    }
    
 }
 
export default clsRelation
